import { AuthenticationError, getErrorMessage } from 'shared/errors';
import { accessAuthTokenApi } from 'app/services/AuthService/api';
import { authStorage } from 'storages';
import { configs, getRedirectCompleteUrl } from 'app/services/AuthService/config';
import { getAuthQueryParams } from 'app/services/AuthService/helpers';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';

export type CompleteAuthorization = (authConfig: AuthConfigInterface) => Promise<void>;
export const completeAuthorization: CompleteAuthorization = async authConfig => {
  try {
    const jwtAuthParams = authStorage.getJwtAuthParams();
    const authQueryParams = getAuthQueryParams();
    const redirectCompleteUrl = getRedirectCompleteUrl();

    if (
      !jwtAuthParams?.state ||
      !jwtAuthParams?.verifier ||
      !authQueryParams.state ||
      !authQueryParams.code
    ) {
      throw new AuthenticationError('incorrect query/localstorage data', {
        query: { ...authQueryParams },
        ls: { ...jwtAuthParams },
      });
    }

    if (jwtAuthParams?.state !== authQueryParams.state) {
      throw new AuthenticationError('incorrect state', {
        query: { ...authQueryParams },
        ls: { ...jwtAuthParams },
      });
    }

    const { access_token, refresh_token } = await accessAuthTokenApi({
      grantTypeCode: configs.grantType.code,
      clientId: authConfig.clientId,
      redirectUrl: redirectCompleteUrl,
      code: authQueryParams.code,
      verifier: jwtAuthParams?.verifier,
    });

    await authStorage.setJwtAuthParams({
      access: access_token,
      refresh: refresh_token,
    });

    window.location.href = jwtAuthParams.returnUrl ?? window.location.origin;
  } catch (error: unknown) {
    const pref = 'CompleteAuthorization: ';
    const errorMessage = getErrorMessage(`${pref}${error}`);

    if (errorMessage) throw new Error(errorMessage);

    throw new AuthenticationError('Catch error while completing authorization!');
  }
};
